import React, { useState, useEffect, useCallback } from "react";
import { withAuthenticationRequired, useAuth0 } from "@auth0/auth0-react";
import Autocomplete from "@mui/material/Autocomplete";
import * as api from "../api/api";
import "reactjs-popup/dist/index.css";
import CloseIcon from "@mui/icons-material/Close";
import "../device/dgstyles.css";
import { StyledIconButton } from "../components/StyledComponents/Buttons/AuradineButtons";
import { Box, Grid, Container, ClickAwayListener, } from "@mui/material";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import PageWrapper from "../components/PageWrapper/PageWrapper.js";
import Chip from "@mui/material/Chip";
import Checkbox from "@mui/material/Checkbox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useDropzone } from "react-dropzone";
import PageLoading from "../components/pageloading";
import PageContainer from "../components/PageContainer";
import {
  H7TitleLarge,
  BodyLarge,
  H9TitleSmall,
  BodySmall,
  H8TitleMedium,
  BodyMedium,
} from "../components/StyledComponents/Typography/Typography.tsx";
import {
  StyledCheckbox,
  StyledTextField,
} from "../components/StyledComponents/Inputs/Inputs";
import {
  OutlinedButton,
  PrimaryButton,
  SecondaryButton,
  StyledAccordion,
  StyledAccordionDetails,
  StyledAccordionSummary,
} from "../components/StyledComponents/Buttons/AuradineButtons";
import { StyledDialog } from "../components/StyledComponents/Dialog/Dialog.js";
import { useTheme } from "../ThemeContext/ThemeContext.js";

const SuccessModal = ({ isOpen, onClose, Status, resultMsg }) => {
  const { colors } = useTheme();
  let h4Msg = "";
  let pMsg = "";
  switch (Status) {
    case "ok":
      h4Msg = "Success Message";
      pMsg = resultMsg;
      break;
    case "importok":
      h4Msg = "Success Message";
      pMsg = resultMsg;
      break;
    case "configok":
      h4Msg = "Success Message";
      pMsg = resultMsg;
      break;
    case "getok":
      h4Msg = "Success Message";
      pMsg = resultMsg;
      break;
    case "importunknown":
      h4Msg = "Import Handler Failed!";
      pMsg = "Unable to import the devices";
      break;
    case "configunknown":
      h4Msg = "Config Handler Failed!";
      pMsg = "Unable to update the config";
    case "fetchfailed":
      h4Msg = "Fetch Failed!";
      pMsg =
        "Unable to fetch the data. Try refreshing the page. If issue still persists, please contact Technical Support at Auradine";
      break;
    case "nouser":
      h4Msg = "Authentication Failed!";
      pMsg =
        "User is not part of the Organization. Please contact your Administrator";
      break;
    case "nottech":
      h4Msg = "Authentication Failed!";
      pMsg =
        "User is not a part of tech support";
      break;
    case "unauth":
      h4Msg = "Authentication Failed!";
      pMsg = "User is not authorized to perform this operation";
      validUser = 0;
      break;
    case "geterror":
      h4Msg = "Failed!";
      if (resultMsg === "" || resultMsg === undefined || resultMsg === null) {
        pMsg = "Response from the server is not as expected.";
      } else {
        pMsg = resultMsg;
      }
      validUser = 0;
      break;
    case "error":
      h4Msg = "Failed!";
      if (resultMsg === "" || resultMsg === undefined || resultMsg === null) {
        pMsg = "Response from the server is not as expected.";
      } else {
        pMsg = resultMsg;
      }
      validUser = 0;
      break;
    case "importerror":
      h4Msg = "Failed!";
      if (resultMsg === "" || resultMsg === undefined || resultMsg === null) {
        pMsg = "Response from the server is not as expected.";
      } else {
        pMsg = resultMsg;
      }
      validUser = 0;
      break;
    case "configerror":
      h4Msg = "Failed!";
      if (resultMsg === "" || resultMsg === undefined || resultMsg === null) {
        pMsg = "Response from the server is not as expected.";
      } else {
        pMsg = resultMsg;
      }
      validUser = 0;
      break;
    default:
      h4Msg = "Unknown Error";
      pMsg = "Unable to fetch the data. Try refreshing the page";
      break;
  }
  if (Status !== "") {
    return (
      <StyledDialog colors={colors} open={isOpen} onClose={onClose} sx={{ overflow: "hidden" }}>
        <Box display="flex" flexDirection="column" gap={2} maxHeight="60vh">
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{ p: 2 }}
          >
            <H8TitleMedium>{h4Msg}</H8TitleMedium>
            <StyledIconButton colors={colors} onClick={onClose} size="small">
              <CloseIcon />
            </StyledIconButton>
          </Box>
          <Box sx={{ p: 2 }} display="flex" justifyContent="flex-start"  alignItems="flex-start">
            {typeof pMsg === "object" ? (
              <Box
                sx={{
                  maxHeight: "400px",
                  overflowY: "auto",
                  backgroundColor: "#f5f5f5",
                  borderRadius: 1,
                  p: 2,
                }}
              >
                <Box component="pre" sx={{ whiteSpace: "pre-wrap", m: 0 }}>
                  {JSON.stringify(pMsg, null, 2)}
                </Box>
                <Box sx={{ mt: 2 }}>
                  <a
                    href={`data:application/json;charset=utf-8,${encodeURIComponent(
                      JSON.stringify(pMsg, null, 2)
                    )}`}
                    download="output.json"
                    style={{
                      textDecoration: "underline",
                      fontSize: "0.875rem",
                    }}
                  >
                    Download JSON
                  </a>
                </Box>
              </Box>
            ) : (
              <BodyMedium sx={{ pr: "1rem", pb: "1rem" }}>{pMsg}</BodyMedium>
            )}
          </Box>
        </Box>
      </StyledDialog>
    );
  }
};

export const HeaderContainer = React.memo((props) => {
  return (
    <Box
      className={"header-container"}
      display={"flex"}
      justifyContent="space-between"
      flexDirection="column"
      gap={4}
      marginBottom={"1.5rem"}
    >
      <Box
        className={"title-box"}
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"space-between"}
        gap={3.5}
      >
        <H7TitleLarge>Tech Support Onboard Operations</H7TitleLarge>
        <BodyLarge>
          Operations related to onboarding organizations into FluxVision.
        </BodyLarge>
      </Box>
    </Box>
  );
});

let validUser = -1;

const TECHSUPPORT_ORG_ID = "techsupport_org_id";

export const TechsupportOnboard = () => {
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const [submitMsg, setSubmitMsg] = useState("");
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const { colors } = useTheme();

  const { user: user0, getAccessTokenSilently } = useAuth0();
  const [showBanner, setShowBanner] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showPopupDevices, setShowPopupDevices] = useState(false);
  const [showPopupConfig, setShowPopupConfig] = useState(false);
  const [inputOrgID, setOrgID] = useState(
    localStorage.getItem(TECHSUPPORT_ORG_ID) || ""
  );
  const [inputOrgName, setOrgName] = useState("");
  const [inputSuperAdminName, setSuperAdminName] = useState("");
  const [inputDesiredAlertInterval, setDesiredAlertInterval] = useState("");
  const [inputSuperAdminEmail, setSuperAdminEmail] = useState("");
  const [inputCurrentSuperAdminEmail, setCurrentSuperAdminEmail] = useState("");
  const [OverwriteSuperAdmin, setOverwriteSuperAdmin] = useState(false);
  const [onboardMsg, setOnboardMsg] = useState("");
  const [dgChassisList, setDGChassisList] = useState([]);
  const [placeholder, setPlaceholder] = useState("Select Miners from the Org");
  const [openTechsupportConfirmation, setOpenTechsupportConfirmation] =
    React.useState(false);
  const [confMessage, setConfMessage] = React.useState("");
  const [confMessage1, setConfMessage1] = React.useState("");
  const [jobMessage, setJobMessage] = React.useState([]);
  const [getTSfail, setGetTSfail] = React.useState(false);

  const [error, setError] = React.useState({
    error: false,
    helperText: "",
  });

  const [expanded, setExpanded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isImporting, setIsImporting] = useState(false);
  const [isDeregister, setIsDeregistering] = useState(false);
  const [isRemoveDevices, setIsRemoveDevices] = useState(false);
  const [isRemoveOrg, setIsRemoveOrg] = useState(false);
  const [isUpdateOrgConfig, setIsUpdateOrgConfig] = useState(false);
  const [dglen, setDGDeviceLen] = React.useState(0);
  const [dgDeviceList1, setDGDevices1] = useState([]);
  const [dgDeviceList, setDGDevices] = useState([]);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [tsDevices, setTSDevices] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [chassisSerialInput, setChassisSerialInput] = useState("");
  const [generateTS, setGenerateTS] = useState(false);
  const [jobTS, setJobTS] = useState(false);
  const [org, setOrg] = useState({
    org_id: "",
    name: "",
    member: [],
    owner: "",
  });

  const [fileContent, setFileContent] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const [ztpfileContent, setZTPFileContent] = useState(null);
  const [ztpsearchQuery, setZTPSearchQuery] = useState("");

  // Assuming fileContent.data is an array of objects
  const filteredData =
    fileContent && fileContent.data
      ? fileContent.data.filter((item) =>
          JSON.stringify(item).toLowerCase().includes(searchQuery.toLowerCase())
        )
      : [];

  const ztpfilteredData =
    ztpfileContent && ztpfileContent.data
      ? ztpfileContent.data.filter((item) =>
          JSON.stringify(item)
            .toLowerCase()
            .includes(ztpsearchQuery.toLowerCase())
        )
      : [];

  useEffect(() => {
    // Set overflow to visible when the component mounts
    document.documentElement.style.overflow = "visible";

    // Cleanup function to reset overflow when the component unmounts
    return () => {
      document.documentElement.style.overflow = "hidden";
    };
  }, []);

  const handleCloseSuccessModal = () => {
    setSuccessModalOpen(false);
  };

  const onDrop = useCallback((acceptedFiles) => {
    const file = acceptedFiles[0];

    // Read the content of the file
    const reader = new FileReader();
    reader.onload = () => {
      const content = reader.result;

      // Parse the JSON content
      try {
        const jsonData = JSON.parse(content);
        // Check if jsonData is an object
        if (jsonData && typeof jsonData === "object") {
          setFileContent({
            isValid: true,
            data: Array.isArray(jsonData) ? jsonData : [jsonData],
          });
        } else {
          throw new Error(
            "Invalid JSON format. Please upload a valid JSON file."
          );
        }
      } catch (error) {
        setFileContent({
          isValid: false,
          errorMessage: "Invalid JSON format. Please upload a valid JSON file.",
        });
      }
    };
    reader.readAsText(file);
  }, []);

  const onDropConfig = useCallback((acceptedFiles) => {
    const file = acceptedFiles[0];

    // Read the content of the file
    const reader = new FileReader();
    reader.onload = () => {
      const content = reader.result;

      // Parse the JSON content
      try {
        const jsonData = JSON.parse(content);
        if (jsonData && typeof jsonData === "object") {
          setZTPFileContent({
            isValid: true,
            data: Array.isArray(jsonData) ? jsonData : [jsonData],
          });
        } else {
          throw new Error(
            "Invalid JSON format. Please upload a valid JSON file."
          );
        }
      } catch (error) {
        setZTPFileContent({
          isValid: false,
          errorMessage: "Invalid JSON format. Please upload a valid JSON file.",
        });
      }
    };
    reader.readAsText(file);
  }, []);

  const {
    getRootProps: getRootPropsConfig,
    getInputProps: getInputPropsConfig,
    isDragActive: isDragActiveConfig,
  } = useDropzone({ onDrop: onDropConfig });

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  useEffect(() => {
    const fn = async () => {
      const token = await getAccessTokenSilently();
      await api.GetUserTechsupport(token, (data) => {
        if (data.status === "error") {
          if (data.errorCode === 1007) {
            validUser = 1;
            setSubmitMsg("nottech");
            setSuccessModalOpen(true);
          } else {
            validUser = 1;
            setSubmitMsg("nottech");
            setSuccessModalOpen(true);
          }
        } else {
          setSuccessModalOpen(true);
          validUser = 0;
        }
      });
    };
    fn();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    const runFn = async () => {
      setSubmitMsg("");
      return;
    };
    runFn();
  }, [inputOrgID]);

  const clearHandler = async () => {
    setOnboardMsg("");
    setOrgID("");
    setOrgName("");
    setSuperAdminName("");
    setDesiredAlertInterval("");
    setSuperAdminEmail("");
    setCurrentSuperAdminEmail("");
    setFileContent(null);
    setZTPFileContent(null);
    setSelectedDevices([]);
    setDGDevices([]);
    setDGDevices1([]);
    setDGChassisList({});
    setDGDeviceLen(0);
    setTSDevices([]);
    setSelectAll(false);
  };

  const GetHandler = async () => {
    const token = await getAccessTokenSilently();
    const info = {};
    info.org_id = inputOrgID;
    info.superadmin_email = inputSuperAdminEmail;
    info.method = "fetch";
    const fetchOnboard = await api.PostOnboard(token, info);
    if (
      fetchOnboard === undefined ||
      !fetchOnboard.hasOwnProperty("status") ||
      fetchOnboard.status === "error"
    ) {
      setSubmitMsg("geterror");
      setOnboardMsg(fetchOnboard.msg);
      setSuccessModalOpen(true);
      setOrgID("");
      setOrgName("");
      setSuperAdminName("");
      setSuperAdminEmail("");
      setCurrentSuperAdminEmail("");
    } else {
      const deviceGroupInfo = await api.GetOrgDevices(token, info);
      if (
        deviceGroupInfo === undefined ||
        deviceGroupInfo === null ||
        (deviceGroupInfo.hasOwnProperty("status") &&
          deviceGroupInfo.status === "error")
      ) {
        setSelectedDevices([]);
        setTSDevices([]);
        setDGDevices([]);
        setDGDevices1([]);
        setDGChassisList({});
        setDGDeviceLen(0);
      } else if (
        deviceGroupInfo.hasOwnProperty("status") &&
        deviceGroupInfo.status === "ok"
      ) {
        if (
          deviceGroupInfo.devicelist &&
          deviceGroupInfo.devicelist.length > 0
        ) {
          setDGDeviceLen(deviceGroupInfo.devicelist.length);
          setDGDevices(deviceGroupInfo.devicelist);
          setDGDevices1(deviceGroupInfo.devicelist);
          setDGChassisList(deviceGroupInfo.chassislist);
          setTSDevices(deviceGroupInfo.devicelist);
          setSelectedDevices([]);
        } else {
          setSelectedDevices([]);
          setTSDevices([]);
          setDGDevices([]);
          setDGDevices1([]);
          setDGChassisList({});
          setDGDeviceLen(0);
        }
      }
      setSubmitMsg("getok");
      setOnboardMsg("Successfully fetched the organization details");
      setSuccessModalOpen(true);
      setOrgID(fetchOnboard.org_id);
      setOrgName(fetchOnboard.org_name);
      setSuperAdminName(fetchOnboard.name);
      setSuperAdminEmail(fetchOnboard.email);
      setTSDevices([]);
    }
    setShowPopup(false);
  };

  const SaveCSDesiredAlertInterval = async () => {
    const token = await getAccessTokenSilently();
    const info = {};
    info.desiredAlertInterval = parseInt(inputDesiredAlertInterval);
    if (isNaN(info.desiredAlertInterval)) {
      setSubmitMsg("geterror");
      setOnboardMsg("Interval should be a number");
      setSuccessModalOpen(true);
      setDesiredAlertInterval("");
      return;
    }
    const resp = await api.PostDesiredAlertIntervalCSTeam(token, info);
    if (
      resp === undefined ||
      !resp.hasOwnProperty("status") ||
      resp.status === "error"
    ) {
      setSubmitMsg("geterror");
      setOnboardMsg(resp.msg);
      setSuccessModalOpen(true);
      setDesiredAlertInterval("");
    } else {
      setSubmitMsg("getok");
      setOnboardMsg("Successfully saved the interval");
      setSuccessModalOpen(true);
    }
    setShowPopup(false);
  };

  const handleCancelConfirmation = () => {
    setShowPopup(false);
  };
  const handleConfirmation = () => {
    submitHandler();
    setIsLoading(false);
    setShowPopup(false);
  };

  const handleImportDevices = async (org_id, jsonData) => {
    setIsImporting(true);

    if (org_id === undefined || org_id === null || org_id.trim() === "") {
      setSubmitMsg("importerror");
      setOnboardMsg("Org ID is empty");
      setSuccessModalOpen(true);
      setIsImporting(false);
      return;
    }
    if (jsonData === undefined || jsonData === null || jsonData.length === 0) {
      setSubmitMsg("importerror");
      setOnboardMsg("Uploaded JSON file either empty or invalid");
      setSuccessModalOpen(true);
      setIsImporting(false);
      return;
    }
    const areKeysPresent = jsonData.every(
      (obj) =>
        "SerialNo" in obj && "TPMPubKey" in obj && "ChassisSerialNo" in obj
    );

    if (!areKeysPresent) {
      setSubmitMsg("importerror");
      setOnboardMsg(
        "Imported Devices does not have keys matching SerialNo or TPMPubKey or ChassisSerialNo. Please check and upload again"
      );
      setSuccessModalOpen(true);
      setIsImporting(false);
      return;
    }

    const token = await getAccessTokenSilently();
    const info = {};
    info.org_id = org_id;
    info.importDevices = jsonData;

    const postImportDevices = await api.PostImportDevices(token, info);
    if (
      postImportDevices === undefined ||
      !postImportDevices.hasOwnProperty("status")
    ) {
      setSubmitMsg("importunknown");
    } else if (postImportDevices.status === "ok") {
      setSubmitMsg("importok");
      setOnboardMsg(postImportDevices);
      setSuccessModalOpen(true);
    } else {
      setSubmitMsg("importerror");
      setOnboardMsg(postImportDevices.msg);
      setSuccessModalOpen(true);
    }
    setIsImporting(false);
  };

  const handleDeregisterDevices = async (org_id, jsonData) => {
    setIsDeregistering(true);

    if (org_id === undefined || org_id === null || org_id.trim() === "") {
      setSubmitMsg("importerror");
      setOnboardMsg("Org ID is empty");
      setSuccessModalOpen(true);
      setIsDeregistering(false);
      return;
    }
    if (jsonData === undefined || jsonData === null || jsonData.length === 0) {
      setSubmitMsg("importerror");
      setOnboardMsg("Uploaded JSON file either empty or invalid");
      setSuccessModalOpen(true);
      setIsDeregistering(false);
      return;
    }
    const areKeysPresent = jsonData.every(
      (obj) => "SerialNo" in obj && "TPMPubKey" in obj
    );

    if (!areKeysPresent) {
      setSubmitMsg("importerror");
      setOnboardMsg(
        "Imported Devices does not have keys matching SerialNo or TPMPubKey. Please check and upload again"
      );
      setSuccessModalOpen(true);
      setIsDeregistering(false);
      return;
    }

    const token = await getAccessTokenSilently();
    const info = {};
    info.org_id = org_id;
    info.deregisterDevices = jsonData;

    const postImportDevices = await api.PostDeregisterDevices(token, info);
    if (
      postImportDevices === undefined ||
      !postImportDevices.hasOwnProperty("status")
    ) {
      setSubmitMsg("importunknown");
    } else if (postImportDevices.status === "ok") {
      setSubmitMsg("importok");
      setOnboardMsg(postImportDevices);
      setSuccessModalOpen(true);
    } else {
      setSubmitMsg("importerror");
      setOnboardMsg(postImportDevices.msg);
      setSuccessModalOpen(true);
    }
    setIsDeregistering(false);
  };

  const handleRemoveDevices = async (org_id, jsonData) => {
    setIsRemoveDevices(true);

    if (org_id === undefined || org_id === null || org_id.trim() === "") {
      setSubmitMsg("importerror");
      setOnboardMsg("Org ID is empty");
      setSuccessModalOpen(true);
      setIsRemoveDevices(false);
      return;
    }
    if (jsonData === undefined || jsonData === null || jsonData.length === 0) {
      setSubmitMsg("importerror");
      setOnboardMsg("Uploaded JSON file either empty or invalid");
      setSuccessModalOpen(true);
      setIsRemoveDevices(false);
      return;
    }
    const areKeysPresent = jsonData.every(
      (obj) => "SerialNo" in obj && "TPMPubKey" in obj
    );

    if (!areKeysPresent) {
      setSubmitMsg("importerror");
      setOnboardMsg(
        "Imported Devices does not have keys matching SerialNo or TPMPubKey. Please check and upload again"
      );
      setSuccessModalOpen(true);
      setIsRemoveDevices(false);
      return;
    }

    const token = await getAccessTokenSilently();
    const info = {};
    info.org_id = org_id; //not used
    info.removeDevices = jsonData;

    const postImportDevices = await api.PostRemoveDevices(token, info);
    if (
      postImportDevices === undefined ||
      !postImportDevices.hasOwnProperty("status")
    ) {
      setSubmitMsg("importunknown");
    } else if (postImportDevices.status === "ok") {
      setSubmitMsg("importok");
      setOnboardMsg(postImportDevices);
      setSuccessModalOpen(true);
    } else {
      setSubmitMsg("importerror");
      setOnboardMsg(postImportDevices.msg);
      setSuccessModalOpen(true);
    }
    setIsRemoveDevices(false);
  };

  const handleRemoveOrg = async (org_id) => {
    setIsRemoveOrg(true);

    if (org_id === undefined || org_id === null || org_id.trim() === "") {
      setSubmitMsg("importerror");
      setOnboardMsg("Org ID is empty");
      setSuccessModalOpen(true);
      setIsRemoveOrg(false);
      return;
    }

    const token = await getAccessTokenSilently();
    const info = {};
    info.org_id = org_id;

    const postOrg = await api.PostRemoveOrgTechsupport(token, info);
    if (postOrg === undefined || !postOrg.hasOwnProperty("status")) {
      setSubmitMsg("importunknown");
    } else if (postOrg.status === "ok") {
      setSubmitMsg("importok");
      setOnboardMsg("Org removed successfully");
      setSuccessModalOpen(true);
    } else {
      setSubmitMsg("importerror");
      setOnboardMsg(postOrg.msg);
      setSuccessModalOpen(true);
    }
    setIsRemoveDevices(false);
  };

  const handleConfig = async (org_id, jsonData) => {
    setIsUpdateOrgConfig(true);

    if (org_id === undefined || org_id === null || org_id.trim() === "") {
      setSubmitMsg("configerror");
      setOnboardMsg("Org ID is empty");
      setSuccessModalOpen(true);
      setIsUpdateOrgConfig(false);
      return;
    }
    if (jsonData === undefined || jsonData === null || jsonData.length === 0) {
      setSubmitMsg("configerror");
      setOnboardMsg("Uploaded JSON file either empty or invalid");
      setSuccessModalOpen(true);
      setIsUpdateOrgConfig(false);
      return;
    }
    const token = await getAccessTokenSilently();
    const info = {};
    if (!jsonData[0].hasOwnProperty("config")) {
      setSubmitMsg("configerror");
      setOnboardMsg("No Config object found in the uploaded JSON file");
      setSuccessModalOpen(true);
      setIsUpdateOrgConfig(false);
      return;
    }
    if (
      jsonData[0].config.hasOwnProperty("ztp") ||
      jsonData[0].config.hasOwnProperty("test")
    ) {
      info.org_id = org_id;
      info.config = jsonData[0].config;
      const postOrgTechsupport = await api.PostOrgTechsupport(token, info);
      if (
        postOrgTechsupport === undefined ||
        !postOrgTechsupport.hasOwnProperty("status")
      ) {
        setSubmitMsg("configunknown");
      } else if (postOrgTechsupport.status === "ok") {
        setSubmitMsg("configok");
        setOnboardMsg("Org Config updated successfully");
        setSuccessModalOpen(true);
      } else {
        setSubmitMsg("configerror");
        setOnboardMsg(postOrgTechsupport.msg);
        setSuccessModalOpen(true);
      }
      setIsUpdateOrgConfig(false);
    } else {
      setSubmitMsg("configerror");
      setOnboardMsg("No ztp object found in the uploaded JSON file");
      setSuccessModalOpen(true);
      setIsUpdateOrgConfig(false);
      return;
    }
  };

  const handleConfigForAllOrgs = async (jsonData) => {
    setIsUpdateOrgConfig(true);

    if (jsonData === undefined || jsonData === null || jsonData.length === 0) {
      setSubmitMsg("configerror");
      setOnboardMsg("Uploaded JSON file either empty or invalid");
      setSuccessModalOpen(true);
      setIsUpdateOrgConfig(false);
      return;
    }
    const token = await getAccessTokenSilently();
    const info = {};
    if (!jsonData[0].hasOwnProperty("config")) {
      setSubmitMsg("configerror");
      setOnboardMsg("No Config object found in the uploaded JSON file");
      setSuccessModalOpen(true);
      setIsUpdateOrgConfig(false);
      return;
    }
    if (
      jsonData[0].config.hasOwnProperty("ztp") ||
      jsonData[0].config.hasOwnProperty("test")
    ) {
      info.org_id = "allOrgs";
      info.config = jsonData[0].config;
      const postOrgTechsupport = await api.PostOrgTechsupport(token, info);
      if (
        postOrgTechsupport === undefined ||
        !postOrgTechsupport.hasOwnProperty("status")
      ) {
        setSubmitMsg("configunknown");
      } else if (postOrgTechsupport.status === "ok") {
        setSubmitMsg("configok");
        setOnboardMsg("Org Config updated successfully");
        setSuccessModalOpen(true);
      } else {
        setSubmitMsg("configerror");
        setOnboardMsg(postOrgTechsupport.msg);
        setSuccessModalOpen(true);
      }
      setIsUpdateOrgConfig(false);
    } else {
      setSubmitMsg("configerror");
      setOnboardMsg("No ztp object found in the uploaded JSON file");
      setSuccessModalOpen(true);
      setIsUpdateOrgConfig(false);
      return;
    }
  };

  const submitHandler = async () => {
    const token = await getAccessTokenSilently();
    const info = {};

    setIsLoading(true);

    info.method = "post";
    info.org_id = inputOrgID;
    info.org_name = inputOrgName.trim();
    info.superadmin_name = inputSuperAdminName.trim();
    info.superadmin_email = inputSuperAdminEmail;
    info.overwrite = OverwriteSuperAdmin;
    info.current_email = inputSuperAdminEmail;
    if (OverwriteSuperAdmin) {
      info.current_email = inputCurrentSuperAdminEmail;
    }
    const postOnboard = await api.PostOnboard(token, info);
    if (postOnboard === undefined || !postOnboard.hasOwnProperty("status")) {
      setSubmitMsg("unknown");
    } else if (postOnboard.status === "ok") {
      setOnboardMsg("Successfully onboarded the organization");
      setSubmitMsg("ok");
    } else {
      setSubmitMsg("error");
      setOnboardMsg(postOnboard.msg);
    }
    setSuccessModalOpen(true);
    setIsLoading(false);
  };

  const handleOrgID = (event) => {
    const value = event.target.value.trim();
    setOrgID(value);
    localStorage.setItem(TECHSUPPORT_ORG_ID, value);
  };
  const handleOrgName = (event) => {
    const value = event.target.value;
    setOrgName(value);
  };
  const handleSuperAdminName = (event) => {
    const value = event.target.value;
    setSuperAdminName(value);
  };
  const handleDesiredAlertInterval = (event) => {
    const value = event.target.value;
    if (/^[0-9]*$/.test(value)) {
      setDesiredAlertInterval(value);
    } else {
      setDesiredAlertInterval("");
    }
  };
  const handleSuperAdminEmail = (event) => {
    const value = event.target.value.trim();
    setSuperAdminEmail(value);
  };

  const handleCurrentSuperAdminEmail = (event) => {
    const value = event.target.value.trim();
    setCurrentSuperAdminEmail(value);
  };

  const handleOverwriteSuperAdmin = () => {
    setOverwriteSuperAdmin(!OverwriteSuperAdmin);
  };

  const selectTSCheckVal = (value) => {
    setTSDevices(value);
    setSelectAll(value.length === dgDeviceList.length);
    if (value.length === dgDeviceList.length) {
      setPlaceholder("");
    } else if (value.length === 0) {
      setPlaceholder(`Select Miners from the Org`);
    } else {
      setPlaceholder("");
    }
  };

  const handleSelectAll = (event) => {
    const allOptions = dgDeviceList;
    const selectedOptions = event.target.checked ? allOptions : [];
    setTSDevices(selectedOptions);
    setSelectAll(event.target.checked);
  };

  const handleCloseTechsupportConfMessage = () => {
    setOpenTechsupportConfirmation(false);
    setJobMessage([]);
    setConfMessage("");
    setConfMessage1("");
    setGenerateTS(false);
    setJobTS(false);
    setGetTSfail(false);
  };

  const handleGenerateTechsupport = async () => {
    setGenerateTS(true);

    // Convert chassis serial numbers to actual serial numbers
    const chassisNumbers = chassisSerialInput.split(',').map(s => s.trim()).filter(s => s !== "");
    const serials = [];
    const invalidChassis = [];

    chassisNumbers.forEach(chassisNum => {
      // Find serial numbers where chassis value exactly matches the input
      const foundSerials = Object.keys(dgChassisList).filter(serial =>
        dgChassisList[serial] === chassisNum && dgChassisList[serial] !== "NA"
      );

      if (foundSerials.length > 0) {
        serials.push(...foundSerials);
      } else {
        invalidChassis.push(chassisNum);
      }
    });

    // Show warning for invalid chassis numbers
    if (invalidChassis.length > 0) {
      console.warn(`Invalid chassis numbers: ${invalidChassis.join(", ")}`);
    }

    setTSDevices(serials);

    if (inputOrgID !== "") {
      const token = await getAccessTokenSilently();
      let request = {};
      request.serials = serials;
      const resp = await api.GenerateTechsupport(token, request);
      if (resp === undefined || resp === null) {
        setOpenTechsupportConfirmation(true);
        setConfMessage(`Error in generating techsupport for ${inputOrgID}`);
      } else if (resp.status === "ok") {
        setOpenTechsupportConfirmation(true);
        let msg =
          "Succeeded in generating techsupport for " +
          inputOrgID +
          " . " +
          resp.msg;
        setConfMessage(msg);
      } else {
        setOpenTechsupportConfirmation(true);
        let msg =
          "Failed to generate techsupport for " + inputOrgID + " . " + resp.msg;
        setConfMessage(msg);
      }
    } else {
      setOpenTechsupportConfirmation(true);
      setConfMessage(`Please select organization id to generate techsupport`);
    }
    setSelectedDevices([]);
  };

  const handleTSJobStatus = async () => {
    setJobTS(true);

    // Convert chassis serial numbers to actual serial numbers (same logic as Generate TS)
    const chassisNumbers = chassisSerialInput.split(',').map(s => s.trim()).filter(s => s !== "");
    const serials = [];
    const invalidChassis = [];

    chassisNumbers.forEach(chassisNum => {
      // Find serial numbers where chassis value exactly matches the input
      const foundSerials = Object.keys(dgChassisList).filter(serial =>
        dgChassisList[serial] === chassisNum && dgChassisList[serial] !== "NA"
      );

      if (foundSerials.length > 0) {
        serials.push(...foundSerials);
      } else {
        invalidChassis.push(chassisNum);
      }
    });

    setTSDevices(serials);

    if (inputOrgID !== "") {
      const token = await getAccessTokenSilently();
      let request = {};
      request.serials = serials;
      request.org_id = inputOrgID;
      const resp = await api.GetTSJobStatus(token, request);
      if (resp === undefined || resp === null) {
        setOpenTechsupportConfirmation(true);
        setConfMessage1(
          `Error in getting techsupport job status for ${inputOrgID}`
        );
        setGetTSfail(true);
      } else if (resp.status === "ok") {
        let msg = resp.msg;
        if (msg.length === 0) {
          msg = "No techsupport job status found for selected miners";
          setConfMessage1(msg);
          setGetTSfail(true);
        } else {
          setJobMessage(msg);
          setGetTSfail(false);
        }
        setOpenTechsupportConfirmation(true);
      } else {
        setOpenTechsupportConfirmation(true);
        let msg =
          "Failed to get techsupport job status for " +
          inputOrgID +
          " . " +
          resp.msg;
        setConfMessage1(msg);
        setGetTSfail(true);
      }
    } else {
      setOpenTechsupportConfirmation(true);
      setGetTSfail(true);
      setConfMessage1(
        `Please select organization id to get techsupport job status`
      );
    }
    setSelectedDevices([]);
  };

  const displayTS = (updatedAt) => {
    const isoDate = updatedAt;
    const localDate = new Date(isoDate);
    const nowDate = Date.now();
    const diffTime = Math.abs(nowDate - localDate); // diffTime in milliseconds
    return localDate.toLocaleString();
  };

  const handleToggle = () => {
    setExpanded((prev) => !prev);
  };

  const handleClickAway = () => {
    if (expanded) {
      setExpanded(false);
    }
  };

  if (validUser === 0) {
    return (
      <PageWrapper>
        <HeaderContainer />
        <Grid
          container
          className={"miner-page-table-container"}
          display={"flex"}
          flexDirection={"row"}
          spacing={4}
          sx={{ transition: "all 0.3s ease-in-out" }}
        >
          <Grid
            item
            xs={12}
            sx={{
              transition: "width 0.3s ease-in-out",
            }}
          >
            <Box
              className={"miner-page-table"}
              display={"flex"}
              flexDirection={"row"}
              backgroundColor={colors.background.paper}
              padding={"0.75rem 0  0.75rem 0"}
              borderRadius={"1rem"}
              sx={{
                transition: "width 0.3s ease-in-out",
              }}
            >
              <Box
                className={"table-container"}
                display={"flex"}
                flexDirection={"column"}
                height={"auto"}
                overflow={"auto"}
                flex={3}
                flexShrink={1}
              >
                <Box sx={{ px: "0.75rem" }}>
                  <Grid
                    container
                    display="flex"
                    flexDirection="row"
                    justifyContent="center"
                    spacing={4}
                    sx={{
                      borderBottom: "1px solid " + colors?.border?.default,
                      transition: "all 0.3s ease-in-out",
                      py: "1rem",
                    }}
                  >
                    <Grid
                      item
                      xs={6}
                      sx={{
                        transition: "width 0.3s ease-in-out",
                      }}
                    >
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        width="100%"
                      >
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="flex-start"
                          sx={{ width: "90%", padding: "0.75rem" }}
                        >
                          <H9TitleSmall>Organization ID</H9TitleSmall>
                          <StyledTextField colors={colors}
                            value={inputOrgID}
                            onChange={handleOrgID}
                            placeholder="Enter Organization ID"
                            fullWidth
                          />
                          <BodySmall mt={"0.5rem"}>
                            If you know the Org ID value, enter and click on the
                            Get button down below to fetch the organization
                            details.
                          </BodySmall>
                        </Box>
                      </Box>
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      sx={{
                        transition: "width 0.3s ease-in-out", // Smooth transition for width
                      }}
                    >
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        width="100%"
                      >
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="flex-start"
                          sx={{ width: "90%", padding: "0.75rem" }}
                        >
                          <H9TitleSmall>Organization Name</H9TitleSmall>
                          <StyledTextField colors={colors}
                            value={inputOrgName}
                            onChange={handleOrgName}
                            fullWidth
                            placeholder="Enter organization name"
                          />
                        </Box>
                      </Box>
                    </Grid>

                    <Grid
                      item
                      xs={6}
                      sx={{
                        transition: "width 0.3s ease-in-out", // Smooth transition for width
                      }}
                    >
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        width="100%"
                      >
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="flex-start"
                          sx={{ width: "90%", padding: "0.75rem" }}
                        >
                          <H9TitleSmall>Super Admin Name</H9TitleSmall>
                          <StyledTextField colors={colors}
                            value={inputSuperAdminName}
                            onChange={handleSuperAdminName}
                            fullWidth
                            placeholder="Enter super admin name"
                          />
                        </Box>
                      </Box>
                    </Grid>

                    <Grid
                      item
                      xs={6}
                      sx={{
                        transition: "width 0.3s ease-in-out", // Smooth transition for width
                      }}
                    >
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        width="100%"
                      >
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="flex-start"
                          sx={{ width: "90%", padding: "0.75rem" }}
                        >
                          <H9TitleSmall>Super Admin Email</H9TitleSmall>
                          <StyledTextField colors={colors}
                            value={inputSuperAdminEmail}
                            onChange={handleSuperAdminEmail}
                            fullWidth
                            placeholder="Enter super admin email address"
                          />
                        </Box>
                      </Box>
                    </Grid>

                    <Grid
                      item
                      xs={6}
                      sx={{
                        transition: "width 0.3s ease-in-out", // Smooth transition for width
                      }}
                    >
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        width="100%"
                      >
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="flex-start"
                          sx={{ width: "90%", padding: "0.75rem" }}
                        >
                          <H9TitleSmall>Replace Super Admin</H9TitleSmall>
                          <Box
                            display="flex"
                            flexDirection="row"
                            alignItems="center"
                            sx={{ mt: "1rem" }}
                            gap={1}
                          >
                            <StyledCheckbox
                              colors={colors}
                              type="radio"
                              value="true"
                              name="OverwriteSuperAdmin"
                              checked={OverwriteSuperAdmin}
                              onChange={handleOverwriteSuperAdmin}
                            />
                            <BodyLarge
                              variant="h7"
                              component="div"
                              sx={{ mr: "1rem" }}
                            >
                              Yes
                            </BodyLarge>
                            <StyledCheckbox
                              colors={colors}
                              type="radio"
                              value="false"
                              name="OverwriteSuperAdmin"
                              checked={!OverwriteSuperAdmin}
                              onChange={handleOverwriteSuperAdmin}
                            />
                            <BodyLarge variant="h7" component="div">
                              No
                            </BodyLarge>
                          </Box>
                        </Box>
                      </Box>
                    </Grid>

                    <Grid
                      item
                      xs={6}
                      sx={{ transition: "width 0.3s ease-in-out" }}
                    >
                      {OverwriteSuperAdmin ? (
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                          width="100%"
                        >
                          <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="flex-start"
                            sx={{ width: "90%", padding: "0.75rem" }}
                          >
                            <H9TitleSmall>
                              Current SuperAdmin Email
                            </H9TitleSmall>
                            <StyledTextField colors={colors}
                              value={inputCurrentSuperAdminEmail}
                              onChange={handleCurrentSuperAdminEmail}
                              placeholder="Enter current super admin email"
                              fullWidth
                            />
                            <BodySmall sx={{ mt: "0.5rem" }}>
                              Proceed with caution: This will overwrite the
                              existing Super Admin details.
                            </BodySmall>
                          </Box>
                        </Box>
                      ) : (
                        <Box
                          display="flex"
                          justifyContent="flex-end"
                          alignItems="flex-end"
                          sx={{
                            width: "98%",
                            height: "80%",
                            px: "1rem",
                          }}
                          gap={4}
                        >
                          <PrimaryButton colors={colors} onClick={clearHandler}>
                            Clear
                          </PrimaryButton>
                          <PrimaryButton colors={colors} onClick={GetHandler}>
                            Get
                          </PrimaryButton>
                          <PrimaryButton colors={colors}
                            onClick={() => {
                              setShowPopup(true);
                            }}
                            disabled={
                              isLoading ||
                              (inputOrgID !== undefined &&
                                inputOrgID !== null &&
                                inputOrgID.trim() === "") ||
                              !inputOrgID.match(/^[a-zA-Z0-9 ]*$/) ||
                              (inputOrgName !== undefined &&
                                inputOrgName !== null &&
                                inputOrgName.trim() === "") ||
                              !inputOrgName.match(/^[a-zA-Z0-9 ]*$/) || // Allowing spaces in OrgName
                              (inputSuperAdminName !== undefined &&
                                inputSuperAdminName !== null &&
                                inputSuperAdminName.trim() === "") ||
                              !inputSuperAdminName.match(/^[a-zA-Z0-9 ]*$/) || // Allowing spaces in SuperAdminName
                              (inputSuperAdminEmail !== undefined &&
                                inputSuperAdminEmail !== null &&
                                inputSuperAdminEmail.trim() === "") ||
                              !inputSuperAdminEmail.match(
                                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,10})+$/
                              ) ||
                              (OverwriteSuperAdmin &&
                                ((inputCurrentSuperAdminEmail !== undefined &&
                                  inputCurrentSuperAdminEmail !== null &&
                                  inputCurrentSuperAdminEmail.trim() === "") ||
                                  !inputCurrentSuperAdminEmail.match(
                                    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,10})+$/
                                  )))
                            }
                          >
                            {isLoading ? "In Progress..." : "Onboard"}
                          </PrimaryButton>
                          <StyledDialog
                            colors={colors}
                            open={showPopup}
                            sx={{ overflow: "hidden" }}
                            onClose={() => setShowPopup(false)}
                          >
                            <Box
                              display="flex"
                              flexDirection="column"
                              gap={3}
                              width="20rem"
                            >
                              <Box
                                display="flex"
                                flexDirection="row"
                                justifyContent="space-between"
                                alignItems="center"
                                sx={{ p: "0.75rem" }}
                              >
                                <H8TitleMedium sx={{ textAlign: "left" }}>
                                  Do you want to onboard?
                                </H8TitleMedium>
                                <StyledIconButton
                                  colors={colors}
                                  onClick={() => setShowPopup(false)}
                                  size="small"
                                >
                                  <CloseIcon />
                                </StyledIconButton>
                              </Box>
                              <Box
                                display="flex"
                                flexDirection="row"
                                justifyContent="center"
                                alignItems="center"
                                gap={5}
                                sx={{ px: "0.75rem", pb: "0.75rem" }}
                              >
                                <OutlinedButton colors={colors}
                                  onClick={handleCancelConfirmation}
                                >
                                  No
                                </OutlinedButton>
                                <PrimaryButton colors={colors} onClick={handleConfirmation}>
                                  Yes
                                </PrimaryButton>
                              </Box>
                            </Box>
                          </StyledDialog>

                          <div>
                            <SuccessModal
                              isOpen={successModalOpen}
                              onClose={handleCloseSuccessModal}
                              Status={submitMsg}
                              resultMsg={onboardMsg}
                            />
                          </div>
                        </Box>
                      )}
                    </Grid>

                    {OverwriteSuperAdmin && (
                      <Grid
                        item
                        xs={12}
                        sx={{ transition: "width 0.3s ease-in-out" }}
                      >
                        <Box
                          display="flex"
                          justifyContent="flex-end"
                          alignItems="flex-end"
                          sx={{
                            width: "99%",
                            p: "1rem",
                          }}
                          gap={4}
                        >
                          <PrimaryButton colors={colors} onClick={clearHandler}>
                            Clear
                          </PrimaryButton>
                          <PrimaryButton colors={colors} onClick={GetHandler}>
                            Get
                          </PrimaryButton>
                          <PrimaryButton colors={colors}
                            onClick={() => {
                              setShowPopup(true);
                            }}
                            disabled={
                              isLoading ||
                              (inputOrgID !== undefined &&
                                inputOrgID !== null &&
                                inputOrgID.trim() === "") ||
                              !inputOrgID.match(/^[a-zA-Z0-9 ]*$/) ||
                              (inputOrgName !== undefined &&
                                inputOrgName !== null &&
                                inputOrgName.trim() === "") ||
                              !inputOrgName.match(/^[a-zA-Z0-9 ]*$/) || // Allowing spaces in OrgName
                              (inputSuperAdminName !== undefined &&
                                inputSuperAdminName !== null &&
                                inputSuperAdminName.trim() === "") ||
                              !inputSuperAdminName.match(/^[a-zA-Z0-9 ]*$/) || // Allowing spaces in SuperAdminName
                              (inputSuperAdminEmail !== undefined &&
                                inputSuperAdminEmail !== null &&
                                inputSuperAdminEmail.trim() === "") ||
                              !inputSuperAdminEmail.match(
                                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,10})+$/
                              ) ||
                              (OverwriteSuperAdmin &&
                                ((inputCurrentSuperAdminEmail !== undefined &&
                                  inputCurrentSuperAdminEmail !== null &&
                                  inputCurrentSuperAdminEmail.trim() === "") ||
                                  !inputCurrentSuperAdminEmail.match(
                                    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,10})+$/
                                  )))
                            }
                          >
                            {isLoading ? "In Progress..." : "Onboard"}
                          </PrimaryButton>
                          <StyledDialog
                            colors={colors}
                            open={showPopup}
                            sx={{ overflow: "hidden" }}
                            onClose={() => setShowPopup(false)}
                          >
                            <Box
                              display="flex"
                              flexDirection="column"
                              gap={3}
                              width="20rem"
                            >
                              <Box
                                display="flex"
                                flexDirection="row"
                                justifyContent="space-between"
                                alignItems="center"
                                sx={{ p: "0.75rem" }}
                              >
                                <H8TitleMedium sx={{ textAlign: "left" }}>
                                  Do you want to onboard?
                                </H8TitleMedium>
                                <StyledIconButton
                                  colors={colors}
                                  onClick={() => setShowPopup(false)}
                                  size="small"
                                >
                                  <CloseIcon />
                                </StyledIconButton>
                              </Box>
                              <Box
                                display="flex"
                                flexDirection="row"
                                justifyContent="center"
                                alignItems="center"
                                gap={5}
                                sx={{ px: "0.75rem", pb: "0.75rem" }}
                              >
                                <OutlinedButton colors={colors}
                                  onClick={handleCancelConfirmation}
                                >
                                  No
                                </OutlinedButton>
                                <PrimaryButton colors={colors} onClick={handleConfirmation}>
                                  Yes
                                </PrimaryButton>
                              </Box>
                            </Box>
                          </StyledDialog>
                          <div>
                            <SuccessModal
                              isOpen={successModalOpen}
                              onClose={handleCloseSuccessModal}
                              Status={submitMsg}
                              resultMsg={onboardMsg}
                            />
                          </div>
                        </Box>
                      </Grid>
                    )}
                  </Grid>
                </Box>
                <Box sx={{ px: "0.75rem" }}>
                  <Grid
                    container
                    display="flex"
                    flexDirection="row"
                    justifyContent="center"
                    spacing={4}
                    sx={{
                      borderBottom: "1px solid " + colors?.border?.default,
                      transition: "all 0.3s ease-in-out",
                      py: "1rem",
                    }}
                  >
                    <Grid
                      item
                      xs={6}
                      sx={{ transition: "width 0.3s ease-in-out" }}
                    >
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{ py: "2rem" }}
                        flexDirection="column"
                        gap={4}
                      >
                        <div
                          {...getRootProps()}
                          className={`dropzone ${isDragActive ? "active" : ""}`}
                        >
                          <input {...getInputProps()} />
                          <SecondaryButton colors={colors} component="button">
                            {isDragActive
                              ? "Drop ImportDevice JSON file here"
                              : "Click or drop ImportDevice JSON file to upload"}
                          </SecondaryButton>
                        </div>

                        {fileContent && fileContent.isValid && (
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{ py: "1rem" }}
                            flexDirection="row"
                            gap={3}
                          >
                            <>
                              <OutlinedButton colors={colors}
                                onClick={() => setShowPopupDevices(true)}
                              >
                                View Devices
                              </OutlinedButton>
                              <StyledDialog
                                colors={colors}
                                open={showPopupDevices}
                                onClose={() => setShowPopupDevices(false)}
                                sx={{ overflow: "hidden" }}
                              >
                                <Box
                                  display="flex"
                                  flexDirection="column"
                                  gap={2}
                                  maxHeight={"60vh"}
                                >
                                  <Box
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    sx={{ p: 1 }}
                                  >
                                    <H8TitleMedium>
                                      Device File Content
                                    </H8TitleMedium>
                                    <StyledIconButton
                                      colors={colors}
                                      onClick={() => setShowPopupDevices(false)}
                                      size="small"
                                    >
                                      <CloseIcon />
                                    </StyledIconButton>
                                  </Box>
                                  <StyledTextField colors={colors}
                                    fullWidth
                                    size="small"
                                    placeholder="Search..."
                                    value={searchQuery}
                                    onChange={(e) =>
                                      setSearchQuery(e.target.value)
                                    }
                                    sx={{ px: "1rem" }}
                                  />
                                  <Box
                                    sx={{
                                      overflowY: "auto",
                                      px: "0.75rem",
                                      py: "1rem",
                                    }}
                                    gap={3}
                                  >
                                    {filteredData.length > 0 ? (
                                      <>
                                        <H9TitleSmall>
                                          Filtered File Content:
                                        </H9TitleSmall>
                                        <Box component="pre" sx={{ m: 0 }}>
                                          {JSON.stringify(
                                            filteredData,
                                            null,
                                            2
                                          )}
                                        </Box>
                                      </>
                                    ) : (
                                      <H9TitleSmall>
                                        No matching results
                                      </H9TitleSmall>
                                    )}
                                  </Box>
                                </Box>
                              </StyledDialog>
                            </>

                            <ClickAwayListener onClickAway={handleClickAway}>
                            <StyledAccordion expanded={expanded} onChange={handleToggle} sx={{ position: "relative" }}>
                              <StyledAccordionSummary
                                expandIcon={<KeyboardArrowDownRoundedIcon />}
                              >
                                <BodyMedium>Manage Devices</BodyMedium>
                              </StyledAccordionSummary>
                              <StyledAccordionDetails
                                sx={{
                                  position: "absolute",
                                  top: "100%",
                                  left: 0,
                                  zIndex: 10,
                                }}
                              >
                                <Box display="flex" flexDirection="column">
                                  <SecondaryButton colors={colors}
                                    onClick={() =>
                                      handleImportDevices(
                                        inputOrgID,
                                        fileContent.data
                                      )
                                    }
                                    disabled={isImporting}
                                  >
                                    Import Devices
                                  </SecondaryButton>
                                  <SecondaryButton colors={colors}
                                    onClick={() =>
                                      handleDeregisterDevices(
                                        inputOrgID,
                                        fileContent.data
                                      )
                                    }
                                    disabled={isDeregister}
                                  >
                                    Deregister Devices
                                  </SecondaryButton>
                                  <SecondaryButton colors={colors}
                                    onClick={() =>
                                      handleRemoveDevices(
                                        inputOrgID,
                                        fileContent.data
                                      )
                                    }
                                    disabled={isRemoveDevices}
                                  >
                                    Delete Devices
                                  </SecondaryButton>
                                </Box>
                              </StyledAccordionDetails>
                            </StyledAccordion>
                            </ClickAwayListener>

                            <OutlinedButton colors={colors}
                              onClick={() => handleRemoveOrg(inputOrgID)}
                              disabled={isRemoveDevices}
                              sx={{ color: "red" }}
                            >
                              Remove Org
                            </OutlinedButton>
                          </Box>
                        )}

                        {/* Error Message for Invalid File */}
                        {fileContent && !fileContent.isValid && (
                          <H9TitleSmall>
                            {fileContent.errorMessage}
                          </H9TitleSmall>
                        )}
                      </Box>
                    </Grid>

                    <Grid
                      item
                      xs={6}
                      sx={{ transition: "width 0.3s ease-in-out" }}
                    >
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{ py: "2rem" }}
                        flexDirection="column"
                        gap={4}
                      >
                        <div
                          {...getRootPropsConfig()}
                          className={`dropzone ${
                            isDragActiveConfig ? "active" : ""
                          }`}
                        >
                          <input {...getInputPropsConfig()} />
                          <SecondaryButton colors={colors} component="button">
                            {isDragActive
                              ? "Drop Config JSON file here"
                              : "Click or drop Config JSON file to upload"}
                          </SecondaryButton>
                        </div>

                        {ztpfileContent && ztpfileContent.isValid && (
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{ py: "1rem" }}
                            flexDirection="row"
                            gap={3}
                          >
                            <OutlinedButton colors={colors} onClick={() => setShowPopupConfig(true)}>
                              View Config
                            </OutlinedButton>
                            <StyledDialog
                              colors={colors}
                              open={showPopupConfig}
                              onClose={() => setShowPopupConfig(false)}
                              sx={{ overflow: "hidden" }}
                            >
                              <Box
                                display="flex"
                                flexDirection="column"
                                gap={2}
                                maxHeight={"60vh"}
                                minWidth={"30rem"}
                              >
                                <Box
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="center"
                                  sx={{ p: 1 }}
                                >
                                  <H8TitleMedium>
                                    Config File Content
                                  </H8TitleMedium>
                                  <StyledIconButton
                                    colors={colors}
                                    onClick={() => setShowPopupConfig(false)}
                                    size="small"
                                  >
                                    <CloseIcon />
                                  </StyledIconButton>
                                </Box>
                                <StyledTextField colors={colors}
                                  fullWidth
                                  size="small"
                                  placeholder="Search..."
                                  value={ztpsearchQuery}
                                  onChange={(e) =>
                                    setZTPSearchQuery(e.target.value)
                                  }
                                  sx={{ px: "1rem" }}
                                />
                                <Box
                                  sx={{
                                    overflowY: "auto",
                                    px: "0.75rem",
                                    py: "1rem",
                                  }}
                                  gap={3}
                                >
                                  {ztpfilteredData.length > 0 ? (
                                    <>
                                      <H9TitleSmall>
                                        Filtered Config Content:
                                      </H9TitleSmall>
                                      <Box component="pre" sx={{ m: 0 }}>
                                        {JSON.stringify(
                                          ztpfilteredData,
                                          null,
                                          2
                                        )}
                                      </Box>
                                    </>
                                  ) : (
                                    <H9TitleSmall>
                                      No matching results
                                    </H9TitleSmall>
                                  )}
                                </Box>
                              </Box>
                            </StyledDialog>

                            <OutlinedButton colors={colors}
                              onClick={() =>
                                handleConfig(inputOrgID, ztpfileContent.data)
                              }
                              disabled={isUpdateOrgConfig}
                            >
                              Update Org Cfg
                            </OutlinedButton>
                            <OutlinedButton colors={colors}
                              onClick={() =>
                                handleConfigForAllOrgs(ztpfileContent.data)
                              }
                              disabled={isUpdateOrgConfig}
                            >
                              Update All Orgs' Cfg
                            </OutlinedButton>
                          </Box>
                        )}
                        {ztpfileContent && !ztpfileContent.isValid && (
                          <H9TitleSmall>
                            {ztpfileContent.errorMessage}
                          </H9TitleSmall>
                        )}
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
                <Box sx={{ px: "0.75rem" }}>
                  <Grid
                    container
                    display="flex"
                    flexDirection="row"
                    justifyContent="center"
                    spacing={4}
                    sx={{
                      transition: "all 0.3s ease-in-out",
                      py: "1rem",
                    }}
                  >
                    {/* <Grid
                      item
                      xs={6}
                      sx={{ transition: "width 0.3s ease-in-out" }}
                    >
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        width="100%"
                      >
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="flex-start"
                          sx={{ width: "90%", padding: "0.75rem" }}
                        >
                          <H9TitleSmall>
                            Desired interval between the alert notifications
                          </H9TitleSmall>
                          <StyledTextField colors={colors}
                            value={inputDesiredAlertInterval}
                            onChange={handleDesiredAlertInterval}
                            placeholder="In minutes (0 to turn off alerts)"
                            fullWidth
                          />
                        </Box>
                        <Box
                          display="flex"
                          flexDirection="row"
                          alignItems="flex-end"
                          justifyContent="flex-end"
                          sx={{ width: "90%", padding: "0.75rem" }}
                        >
                          <PrimaryButton colors={colors} onClick={SaveCSDesiredAlertInterval}>
                            Save
                          </PrimaryButton>
                        </Box>
                      </Box>
                    </Grid> */}
                    <Grid
                      item
                      xs={6}
                      sx={{
                        transition: "width 0.3s ease-in-out", // Smooth transition for width
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between", // Space between sections
                        height: "100%", // Ensures the Grid takes up full vertical space
                      }}
                    >
                      {dgDeviceList1.length > 0 && inputOrgID !== "" && (
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                          width="100%"
                          sx={{ flex: 1 }} // Ensures this Box takes up the remaining space
                        >
                          <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="flex-start"
                            sx={{ width: "90%", padding: "0.75rem" }}
                          >
                            <H9TitleSmall>
                              Enter Chassis Serial Numbers
                            </H9TitleSmall>

                            <Box
                              display="flex"
                              flexDirection="row"
                              alignItems="center"
                              sx={{ width: "100%" }}
                              gap={2}
                            >
                              <StyledTextField
                                colors={colors}
                                fullWidth
                                value={chassisSerialInput}
                                onChange={(event) => setChassisSerialInput(event.target.value)}
                                placeholder="Enter chassis serial numbers (comma separated)"
                                aria-label="Chassis Serial Numbers Input"
                              />
                            </Box>
                          </Box>
                          <Box
                            display="flex"
                            justifyContent="flex-end"
                            sx={{
                              width: "90%",
                              padding: "0.75rem",
                              marginTop: "auto",
                            }}
                            gap={4}
                          >
                            <PrimaryButton colors={colors}
                              onClick={handleGenerateTechsupport}
                              disabled={
                                inputOrgID === "" || chassisSerialInput.trim() === ""
                              }
                            >
                              Generate TS
                            </PrimaryButton>

                            {generateTS && (
                              <StyledDialog
                                colors={colors}
                                open={openTechsupportConfirmation}
                                onClose={handleCloseTechsupportConfMessage}
                                sx={{ overflow: "hidden" }}
                              >
                                <Box
                                  display="flex"
                                  flexDirection="column"
                                  gap={2}
                                  maxHeight="60vh"
                                >
                                  <Box
                                    sx={{
                                      p: "1rem",
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                    gap={4}
                                  >
                                    <H8TitleMedium>
                                      Tech Support Confirmation
                                    </H8TitleMedium>
                                    <Box>
                                      <BodyMedium>{confMessage}</BodyMedium>
                                    </Box>
                                  </Box>
                                  <Box
                                    display="flex"
                                    justifyContent="flex-end"
                                    sx={{ p: 1 }}
                                  >
                                    <SecondaryButton colors={colors}
                                      onClick={
                                        handleCloseTechsupportConfMessage
                                      }
                                    >
                                      Ok
                                    </SecondaryButton>
                                  </Box>
                                </Box>
                              </StyledDialog>
                            )}

                            <PrimaryButton colors={colors}
                              onClick={handleTSJobStatus}
                              disabled={
                                inputOrgID === "" || chassisSerialInput.trim() === ""
                              }
                            >
                              Get TS Job Status
                            </PrimaryButton>

                            {jobTS && (
                              <StyledDialog
                                colors={colors}
                                open={openTechsupportConfirmation}
                                onClose={handleCloseTechsupportConfMessage}
                                sx={{ overflow: "hidden" }}
                              >
                                <Box
                                  display="flex"
                                  flexDirection="column"
                                  gap={2}
                                  maxHeight="60vh"
                                >
                                  {getTSfail === false &&
                                    jobMessage.length > 0 && (
                                      <Box
                                        sx={{
                                          p: "1rem",
                                          display: "flex",
                                          flexDirection: "column",
                                        }}
                                        gap={4}
                                      >
                                        <H8TitleMedium>
                                          Tech Support Job Details
                                        </H8TitleMedium>
                                        <Box>
                                          {jobMessage.map((item, index) => (
                                            <div key={index}>
                                              <BodyMedium>
                                                <strong>SerialNo:</strong>{" "}
                                                {item.SerialNo},{" "}
                                                <strong>JobID:</strong>{" "}
                                                {item.JobID},{" "}
                                                <strong>JobStatus:</strong>{" "}
                                                {item.JobStatus},{" "}
                                                <strong>updatedAt:</strong>{" "}
                                                {displayTS(item.updatedAt)}
                                              </BodyMedium>
                                              <br />
                                            </div>
                                          ))}
                                        </Box>
                                      </Box>
                                    )}

                                  {getTSfail === true && (
                                    <Box
                                      sx={{
                                        p: "1rem",
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                      gap={4}
                                    >
                                      <H8TitleMedium>
                                        Tech Support Failure
                                      </H8TitleMedium>
                                      <Box>
                                        <BodyMedium>{confMessage1}</BodyMedium>
                                      </Box>
                                    </Box>
                                  )}

                                  <Box
                                    display="flex"
                                    justifyContent="flex-end"
                                    sx={{ p: 1 }}
                                  >
                                    <SecondaryButton colors={colors}
                                      onClick={
                                        handleCloseTechsupportConfMessage
                                      }
                                    >
                                      Ok
                                    </SecondaryButton>
                                  </Box>
                                </Box>
                              </StyledDialog>
                            )}
                          </Box>
                        </Box>
                      )}
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </PageWrapper>
    )} else {
      return (
        <PageWrapper />
      )
    }
};

export default TechsupportOnboard;
